import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Button from "./Button";

const Wrapper = styled.div`
  margin: ${({ theme }) => theme.spacer * 2}px
    ${({ theme }) => theme.spacer * 1.5}px;

  ${({ theme }) => theme.mediaQueries.medium} {
    margin: ${({ theme }) => theme.spacer * 2.5}px
      ${({ theme }) => theme.spacer * 4}px;
  }

  h2 {
    ${({ theme }) => theme.mediaQueries.medium} {
      display:inline-block;
      width:66%;
    }
  }

  .button-container {
    @media print {
        display:none;    
    }
    ${({ theme }) => theme.mediaQueries.medium} {
      display:inline-block;
      width:33%;
    }

    margin-top:20px;

    button {
      width:100%;
    }
  }
`;


const ProductsHeading = ({ className, heading, buttonText, buttonLink }) => {
  const classes = ["PageHeading"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")}>
      <h2>{heading}</h2>
      <div className="button-container">
        <Button onClick={() => window.open(buttonLink, "_blank")}>
          {buttonText}          
        </Button>
      </div>      
    </Wrapper>
  );
};

ProductsHeading.displayName = "ProductsHeading";

ProductsHeading.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string,
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,
};

ProductsHeading.defaultProps = {
  className: null,
  heading: '',
  buttonText: '',
  buttonLink: 'dasfasdfasdfasd',
};

export default ProductsHeading;
